<div class="mobile-template">
  <kendo-grid [data]="steps" [height]="'auto'">
    <!-- Mobile Template -->
    <ng-template kendoGridToolbarTemplate>
          <div class="grid-toolbar-title">
            {{ "circ_details_header_steps" | i18n }}
          </div>
          <help-link [target]="helpTarget"></help-link>
          <kendo-grid-spacer></kendo-grid-spacer>
          <ece-btn-add
            [title]="'circ_details_button_addStep' | i18n"
            (click)="addStep()"
            *ngIf="canAddStep"
          >
            {{ "circ_details_button_addStep" | i18n }}
          </ece-btn-add>
          <ece-btn-sort
            [title]="'circ_details_button_reorderSteps' | i18n"
            (click)="reorderSteps()"
            *ngIf="canAddStep"
          >
            {{ "circ_details_button_reorderSteps" | i18n }}
          </ece-btn-sort>
    </ng-template>
    <kendo-grid-column >
      <help-link [target]="helpTarget"></help-link>
      <ng-template kendoGridCellTemplate let-x>
        <h5>
          {{ x.payload.data.title }}
        </h5>
        <div class="d-flex flex-row align-center">
          <circ-step-status [circStatus]="circStatus" [step]="x"></circ-step-status>
        </div>
        <div class="nobr">{{ x.dueDate | i18nDate: { date: "medium" } }}</div>

        <div class="d-flex flex-row justify-flex-start flex-wrap">
          <circ-task-details
            class="assignees"
            *ngFor="let a of x.tasks.assignees"
            [assignee]="a"
          >
          </circ-task-details>

        <circ-task-comment
          *ngFor="let a of x.tasks.assignees"
          [assignee]="a"
        ></circ-task-comment>

          <ece-btn-taskEdit
            class="mobile-button px-3"
            *ngIf="x.canWorkStep"
            [title]="'step_details_steps_work_title' | i18n"
            (click)="onWork(x)"
          ></ece-btn-taskEdit>
          <ece-btn-forward
            class="mobile-button px-3"
            *ngIf="x.canWorkStep"
            [title]="'step_details_steps_forward' | i18n"
            (click)="onForward(x)"
          ></ece-btn-forward>
          <ece-btn-edit
            class="mobile-button px-3"
            *ngIf="x.canEditStep"
            [title]="'step_details_steps_edit' | i18n"
            (click)="onEdit(x)"
          ></ece-btn-edit>
          <ece-btn-forward-admin
            class="mobile-button px-3"
            *ngIf="x.canOverrideStep"
            [title]="'step_details_steps_override' | i18n"
            (click)="onOverrideStep(x)"
          ></ece-btn-forward-admin>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<div class="desktop-template">
  <kendo-grid [data]="steps" [height]="'auto'">
    <ng-template kendoGridToolbarTemplate>
      <div class="grid-toolbar-title">
        {{ "circ_details_header_steps" | i18n }}
      </div>
      <help-link [target]="helpTarget"></help-link>

      <kendo-grid-spacer></kendo-grid-spacer>

      <ece-btn-add
        [title]="'circ_details_button_addStep' | i18n"
        (click)="addStep()"
        *ngIf="canAddStep"
      >
        {{ "circ_details_button_addStep" | i18n }}
      </ece-btn-add>

      <ece-btn-sort
        [title]="'circ_details_button_reorderSteps' | i18n"
        (click)="reorderSteps()"
        *ngIf="canAddStep"
      >
        {{ "circ_details_button_reorderSteps" | i18n }}
      </ece-btn-sort>
    </ng-template>
    <!-- Medium Sized Template -->
    <kendo-grid-column [title]="'grid_title' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.payload.data.title }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'grid_dueDate' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.dueDate | i18nDate: { date: "medium" } }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'grid_status' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        <circ-step-status [circStatus]="circStatus" [step]="x"></circ-step-status>
      </ng-template>
    </kendo-grid-column>

    <!-- Large Sized Template  -->
    <kendo-grid-column [title]="'grid_assignedTo' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        <div class="d-flex flex-row justify-flex-start flex-wrap">
          <circ-task-details
            class="assignees"
            *ngFor="let a of x.tasks.assignees"
            [assignee]="a"
          >
          </circ-task-details>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'grid.comment' | i18n">
      <ng-template kendoGridCellTemplate let-x>
        <circ-task-comment
          *ngFor="let a of x.tasks.assignees"
          [assignee]="a"
        ></circ-task-comment>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column>
      <!-- actions -->
      <ng-template kendoGridCellTemplate let-x>
        <ece-btn-taskEdit
          *ngIf="x.canWorkStep"
          [title]="'step_details_steps_work_title' | i18n"
          (click)="onWork(x)"
        >
        </ece-btn-taskEdit>
        <ece-btn-forward
          *ngIf="x.canWorkStep"
          [title]="'step_details_steps_forward' | i18n"
          (click)="onForward(x)"
        >
        </ece-btn-forward>
        <ece-btn-edit
          *ngIf="x.canEditStep"
          [title]="'step_details_steps_edit' | i18n"
          (click)="onEdit(x)"
        >
        </ece-btn-edit>
        <ece-btn-forward-admin
          *ngIf="x.canOverrideStep"
          [title]="'step_details_steps_override' | i18n"
          (click)="onOverrideStep(x)"
        >
        </ece-btn-forward-admin>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
    </kendo-grid-messages>

    <ng-template kendoGridDetailTemplate let-x>
      <section>
        <div class="d-flex expandable-wrap">
          <p>
            <strong>{{ "grid_status" | i18n }}:</strong>
            <circ-step-status [circStatus]="circStatus" [step]="x"></circ-step-status>
            {{ x.tasks.assignees[0].result }}
          </p>
          <p>
            <strong>{{ "step_expanded_forwards" | i18n }}:</strong>
            <circ-step-current-forwarded
              [currentAssignee]="x.tasks.assignees[0]"
              [assignees]="x.tasks.assignees"
            >
            </circ-step-current-forwarded>
          </p>
          <div *ngIf="x.payload.data" class="d-flex flex-column">
            <strong>{{ "step_details_comment" | i18n }}:</strong>
            {{ x.payload.data.comment }}
          </div>
        </div>
      </section>
    </ng-template>
  </kendo-grid>
</div>
